import React from "react";
import ArrayField from "@mbdb_deposit/buildingBlocks/ArrayField";
import FormWrapper from "@mbdb_deposit/buildingBlocks/FormWrapper";
import { useFormikContext } from "formik";
import OptionField from "@mbdb_deposit/buildingBlocks/OptionField";
import { getIn } from "formik";
import CreateOptions from "@mbdb_deposit/buildingBlocks/CreateOptions";
import UseDefault from "@mbdb_deposit/buildingBlocks/UseDefault";
import Protocol from "@mbdb_deposit/sharedComponents/Protocol";
import EntityAndConcentration from "@mbdb_deposit/sharedComponents/EntityAndConcentration";

function SampleInSyringe({ name, colorSchema }) {
  const { values } = useFormikContext();
  UseDefault(`${name}.targets`, [{}]);

  const tooltips = {
    preparationProtocol:
      "List of steps taken to prepare the sample, ending at the point where it was placed in the measurement container. Information include operations like filtration and which filter material and pore-size was used should be added",
    target:
      "List of names (ids), from the entities of interest defined in the record, of directly measured entities",
  };

  const chemicalEnvironmentsValue = getIn(
    values,
    `metadata.general_parameters.chemical_environments`
  );
  const chemicalEnvironmentsOptions = CreateOptions(
    chemicalEnvironmentsValue,
    "Select Chemical environment, if applicable"
  );

  return (
    <>
      <FormWrapper
        headline="Sample in syringe"
        colorSchema={colorSchema}
        tooltip="Composition of the solution in the syringe including targets and chemical environment"
        required
        name={name}
      >
        <OptionField
          name={name}
          label="Chemical environment"
          fieldName="chemical_environment"
          required
          options={chemicalEnvironmentsOptions}
          tooltip="Name (id) of the chemical environment of the sample (from the chemical environments defined in the record)"
        />

        <ArrayField
          name={name}
          label="Preparation protocol"
          fieldName="preparation_protocol"
          tooltip={tooltips.preparationProtocol}
          renderChild={({ arrayName, index }) => (
            <FormWrapper
              headline={`Preparation protocol step ${index + 1}`}
              tooltip={tooltips.preparationProtocol}
            >
              <Protocol name={`${arrayName}.${index}`} />
            </FormWrapper>
          )}
        />

        <ArrayField
          name={name}
          label="Target"
          fieldName="targets"
          required
          tooltip={tooltips.target}
          renderChild={({ arrayName, index }) => (
            <FormWrapper
              headline={`Target ${index + 1}`}
              tooltip={tooltips.target}
              name={arrayName}
            >
              <EntityAndConcentration name={`${arrayName}.${index}`} />
            </FormWrapper>
          )}
        />
      </FormWrapper>
    </>
  );
}

export default SampleInSyringe;
